import { ModelBase } from 'store/model-base';

export class Quickpayment extends ModelBase {
    public static storeName: string = 'quickpayment';

    public isUsingSameAmount: boolean;
    public amount: number;
    public userData: OneTimePaymentNewCardInfo;
    public email?: string;
}
